export class Config {
}
Config.isAntialias = true;
Config.useWebGL2 = true;
Config.useSPRIV = false;
Config.matUseUBO = true;
Config.enableUniformBufferObject = true;
Config.FPS = 60;
Config.useRetinalCanvas = false;
Config.animationInterval = 50;
Config.webGL2D_MeshAllocMaxMem = true;
Config.defaultFontSize = 12;
Config.defaultFont = "Arial";
Config.isAlpha = false;
Config.isDepth = false;
Config.isfailIfMajorPerformanceCaveat = false;
Config.powerPreference = "default";
Config.premultipliedAlpha = true;
Config.isStencil = true;
Config.preserveDrawingBuffer = false;
Config.printWebglOrder = false;
Config.fontFamilyMap = { "报隶": "报隶-简", "黑体": "黑体-简", "楷体": "楷体-简", "兰亭黑": "兰亭黑-简", "隶变": "隶变-简", "凌慧体": "凌慧体-简", "翩翩体": "翩翩体-简", "苹方": "苹方-简", "手札体": "手札体-简", "宋体": "宋体-简", "娃娃体": "娃娃体-简", "魏碑": "魏碑-简", "行楷": "行楷-简", "雅痞": "雅痞-简", "圆体": "圆体-简" };
Config.fixedFrames = true;
Config.destroyResourceImmediatelyDefault = true;
Config.audioBufferCacheMaxSize = 5 * 1024 * 1024;
export const PlayerConfig = {};
